module.exports = __webpack_public_path__ + "site/img/49.72523c90.jpg";